module.exports = __webpack_public_path__ + "mainassets/img/meshlin_pin.09725bc4.svg";